import { render, staticRenderFns } from "./SinPermiso.vue?vue&type=template&id=69695ab6&lang=pug"
import script from "./SinPermiso.vue?vue&type=script&lang=js"
export * from "./SinPermiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports